export const USER = {
  USER_ALREADY_EXISTS: 'USER000101',
}

export const MESSAGE = {
  DELETE_TIME_LIMIT_MS: 5 * 60 * 1000, // 5 minutes in milliseconds
  DELETE_SCOPE: {
    FOR_ME: 'for_me',
    FOR_EVERYONE: 'for_everyone',
  } as const,
}
